/* eslint-disable react/prop-types */
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useAuth } from '../globalFunctions/AuthContext';
import Loader from '../Views/Common/Cred/Loader';
import { Spin } from 'antd';
export function RouteWithLayout({
	layout: Layout,
	component: Component,
	roles, // ['admin'] or ['student']
	...rest
}) {
	const { user, loading } = useAuth();
	return (
		<Route
			{...rest}
			render={(props) => {
				// Wait for auth check
				if (loading) {
					return <Spin spinning={true} size="large" indicator={<Loader/>}></Spin>;
				}
				// Not authenticated
				if (!user) {
					return <Redirect to="/"/>;
				}
				// Role-based access control
				if (roles && !roles.includes(user.role)) {
					if (!user) {
						return <Redirect to="/"/>;
					} else if (user.role === "admin") {
						return <Redirect to="/admin-dashboard"/>;
					} else {
						return <Redirect to="/home"/>;
					}
				}
				// Authenticated
				return (
					<Layout {...props} {...rest}>
						<Component {...props} {...rest}/>
					</Layout>
				);
			}}
		/>
	);
}
